var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChargingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 13.396",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".prefix__charging-icon-1{fill:currentColor}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-505.18 -859.64)",
    "data-name": "Gruppe 27371"
  }, /*#__PURE__*/React.createElement("path", {
    className: "prefix__charging-icon-1",
    d: "M519.053 866.674h-3.059v-.57h3.059a2.133 2.133 0 000-4.266h-3.059v-.933a1.269 1.269 0 00-1.267-1.267h-2.847a6.7 6.7 0 000 13.4h2.848a1.269 1.269 0 001.267-1.267v-.829h3.059a2.133 2.133 0 000-4.266zm0-3.077a.375.375 0 010 .75h-3.059v-.75zm-7.172 7.681a4.94 4.94 0 010-9.88h2.356v1.293a.2.2 0 00-.006.028v2.508a.2.2 0 00.006.028v2.271a.2.2 0 00-.006.028v2.508a.2.2 0 00.006.028v1.188zm7.172-2.1h-3.059v-.75h3.059a.375.375 0 010 .75z",
    "data-name": "Pfad 13875"
  }), /*#__PURE__*/React.createElement("path", {
    className: "prefix__charging-icon-1",
    transform: "translate(.952 1.393)",
    d: "m511.13 862.61-2.385 1.476 1.042 1.042-1.178 1.8 2.609-1.774-1.042-1.042z",
    "data-name": "Pfad 13876"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChargingIcon);
export default __webpack_public_path__ + "static/media/chargingIcon.f8e9a297ba1dd1916723d43a57cefe76.svg";
export { ForwardRef as ReactComponent };